import { Component, Input } from '@angular/core';

import { VtmnPlayIconTypeEnum } from '../vtmn-play-icon/enums/vtmn-play-icon-type.enum';

@Component({
  selector: 'app-loyalty-points-card',
  templateUrl: './loyalty-points-card.component.html',
  styleUrls: ['./loyalty-points-card.component.scss'],
})
export class LoyaltyPointsCardComponent {
  @Input() public ecological?: boolean;
  @Input() public link: string;

  public readonly iconType = VtmnPlayIconTypeEnum;
}
